


























import {Component, Prop, Vue} from 'vue-property-decorator';
import { v4 as uuid } from 'uuid';
import { copyToClipboard } from '@/classes/utils';

@Component
export default class NodeRedIntegration extends Vue {
  @Prop() private integrationDetails!: any;

  private created() {
    if (!this.integrationDetails.token) {
      this.$emit('update:detail', {key: 'token', value: uuid()});
    }
  }

  get clipboard() {
    return copyToClipboard;
  }

}
